import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { channelsFieldsByShortName } from "../../../../data/app__channelFields";
import { Skeleton } from "../Components";
import { withRefluxStore, PreviewStore } from "../../../../Stores";

import JobPageTab from "./JobPageTab";
import QualificationQuestionsTab from "./QualificationQuestionsTab";
import Channel from "./Channel";

import {
  ChannelSelectorWrapper,
  SidebarChannelsText,
  SingleSidebarSection
} from "./SideBarChannels.styled";
import { useCampaignContext } from "../../../../context/Campaign.context";

const SideBarSkeleton = () => (
  <ChannelSelectorWrapper>
    <Skeleton width="215px" height="40px" margin="0 0 4px 0" borderRadius="4px" />
    <Skeleton width="215px" height="40px" margin="0 0 4px 0" borderRadius="4px" />
    <Skeleton width="215px" height="40px" margin="0 0 4px 0" borderRadius="4px" />
    <Skeleton width="215px" height="40px" borderRadius="4px" />
  </ChannelSelectorWrapper>
);

const SideBarChannels = ({
  selectedPreviewChannel,
  changePreviewChannel,
  clientView,
  setShowAts,
  setShowLeadForm,
  hasAts = false,
  // Props from Store
  userProfile,
  campaignData,
  campaignCreationLoadingState,
  jobPageLink
}) => {
  const { t } = useTranslation();
  const { selectedChannels } = useCampaignContext();

  // Since we don't have independent loading state for Instagram, YouTube and EBay, we have
  // to take the loading state from their matching channels: Facebook and Google Display
  const mappedCampaignCreationLoadingState = useMemo(() => {
    const newCampaignCreationLoadingState = { ...campaignCreationLoadingState };
    newCampaignCreationLoadingState.instagram = newCampaignCreationLoadingState.facebook;
    newCampaignCreationLoadingState.youtube = newCampaignCreationLoadingState["google-display"];
    newCampaignCreationLoadingState["ebay-kleinanzeigen"] =
      newCampaignCreationLoadingState["google-display"];
    return newCampaignCreationLoadingState;
  }, [campaignCreationLoadingState]);

  if (!selectedChannels.length) return <SideBarSkeleton />;

  return (
    <ChannelSelectorWrapper>
      <SingleSidebarSection>
        <SidebarChannelsText>{t("Selected Channels")}</SidebarChannelsText>
        {selectedChannels?.map((channel) => (
          <Channel
            key={channel}
            channel={channel}
            active={channel === selectedPreviewChannel}
            changePreviewChannel={changePreviewChannel}
            clientView={clientView}
            campaignId={campaignData[channelsFieldsByShortName[channel]?.name]}
            jobTitle={campaignData.jobTitle}
            loading={mappedCampaignCreationLoadingState[channel]}
            googleAdwordsAddition={userProfile?.googleAdwordsAddition}
            fbAccountId={campaignData.fbAccountId}
            googleAdsAccountId={campaignData.googleAdsAccountId}
            twitterCampaignId={campaignData.twitterCampaignId}
          />
        ))}
      </SingleSidebarSection>
      {hasAts && (
        <SingleSidebarSection>
          <SidebarChannelsText>{t("Candidate Journey")}</SidebarChannelsText>
          <JobPageTab
            setShowLeadForm={setShowLeadForm}
            active={"leadForm" === selectedPreviewChannel}
            campaignId={campaignData.id}
            clientView={clientView}
            jobPageLink={jobPageLink}
          />
          <QualificationQuestionsTab
            setShowAts={setShowAts}
            active={"ats" === selectedPreviewChannel}
          />
        </SingleSidebarSection>
      )}
    </ChannelSelectorWrapper>
  );
};

export default withRefluxStore(
  SideBarChannels,
  [PreviewStore],
  ["userProfile", "campaignData", "campaignCreationLoadingState", "jobPageLink"]
);
